<div class="container" style="margin-top: 10px;">
    <form [formGroup]="viewLogList">
        <mat-card class="no_box_shadow">
            <mat-card-content>
                <table mat-table matSort [dataSource]="viewLogListDataSource" (matSortChange)="sortData($event)">
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef class="header">
                            <div class="sorting_header">
                                <span mat-sort-header>User Id</span>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.id}}</td>
                    </ng-container>
                

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="header">
                            <div class="sorting_header">
                                <span mat-sort-header>User Name</span>
                                </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.name}}</td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef class="header">
                            <div class="sorting_header">
                                <span mat-sort-header>Status</span>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.status}}</td>
                    </ng-container>

                    <ng-container matColumnDef="triggerStatus">
                        <th mat-header-cell *matHeaderCellDef class="header">
                            <div class="sorting_header">
                                <span mat-sort-header>Triggered/Approved</span>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.triggerStatus}}</td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef class="header">
                            <div class="sorting_header">
                                <span mat-sort-header>Date</span>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.date}}</td>
                    </ng-container>

                    <ng-container matColumnDef="time">
                        <th mat-header-cell *matHeaderCellDef class="header">
                            <div class="sorting_header">
                                <span mat-sort-header>Time</span>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.time}}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="viewColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: viewColumns;"></tr>
                </table>

            </mat-card-content>
        </mat-card>
    </form>
</div>
